import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";


@Options({
    template: false,
    ui: {
        seemoreToggle:      "[data-js-ui=seemore-toggle]",
    }
})

export default class SeeMore extends Marionette.View<Backbone.Model>{

    @on("click @ui.seemoreToggle")
    onSeeMoreClick(e) {
        $(".gallery--series__item--hidden").removeClass("gallery--series__item--hidden");
        $(e.currentTarget).hide();
    }

}



// WEBPACK FOOTER //
// ./@modules/views/see-more.ts